import { Redirect } from 'react-router-dom';

import { PATH } from '../constants/path';
import { LOCALES } from '../constants/locale';

import { localizeRoutes } from '../utils/routeUtils';

import NotFoundPage from '../components/pages/notfound/NotFoundPage';
import InterstitielComponent from '../components/pages/interstitiel/InterstitielComponent';
import ToolbarPage from '../components/pages/toolbar/ToolbarPage';
import ToolbarInstallationPage from '../components/pages/toolbar/ToolbarInstallationPage';

/**
 * Routes to be prefixed with locale
 * Put all the primary routes (i.e all the routes that d'on depend on a parent route to be displaying)
 */
const localizableRoutes = [
    {
        path: PATH.HOME_PATH,
        exact: true,
        component: Redirect,
        to: PATH.TOOLBAR_PATH
    },
    {
        path: PATH.TOOLBAR_PATH,
        exact: true,
        component: ToolbarPage
    },
    {
        path: PATH.TOOLBAR_POST_INSTALL_PATH,
        exact: true,
        component: ToolbarInstallationPage
    },
    {
        path: `${PATH.INTERSTITIEL_TOOLBAR_CASHBACK_PATH}:partnerId/:clickSource/:browser?`,
        component: InterstitielComponent
    },
    {
        path: `${PATH.INTERSTITIEL_TOOLBAR_REDUCTION_PATH}:partnerId/:clickSource/:browser/:couponId`,
        component: InterstitielComponent
    }
];

export const routes = [
    ...localizableRoutes,
    ...localizeRoutes(LOCALES, localizableRoutes),
    {
        path: PATH.NOT_FOUND_PATH,
        exact: true,
        component: NotFoundPage
    },
    {
        component: NotFoundPage
    }
];

export const allRoutes = [...routes];



// WEBPACK FOOTER //
// ./src/routes/index.js